// extracted by mini-css-extract-plugin
export default {"shake":"GameGrid_shake__F4KuA","tilt-shaking":"GameGrid_tilt-shaking__T9Ui9","shake-horizontal":"GameGrid_shake-horizontal__rK1kz"};